import { useMemo } from 'react';
import gql from 'graphql-tag';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from 'react-apollo';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';

export const useIsHighlightOptionPanelEnabled = () => {
	const { userId } = useSessionData();
	// eslint-disable-next-line graphql-client-usage/graphql-generic-types
	const { data, loading, error } = useQuery(
		gql`
			query useIsHighlightOptionPanelEnabledQuery {
				userPreferences {
					highlightOptionPanelEnabled
				}
			}
		`,
		{
			fetchPolicy: 'cache-and-network',
			skip: !userId,
		},
	);

	return useMemo(() => {
		// We always want to default to true until we get a result
		let isHighlightOptionPanelEnabled = true;

		if (error) {
			// We always want to handle errors caused from this, just default to existing behavior
			markErrorAsHandled(error);
		}

		if (!loading && data?.userPreferences) {
			isHighlightOptionPanelEnabled = data?.userPreferences.highlightOptionPanelEnabled;
		}

		return { isHighlightOptionPanelEnabled };
	}, [data, loading, error]);
};
